/**
 * Turn the newsletter field off for someone who is already on the list.
 *
 * The answer comes from /apps/portal/api/subscription, which reports on the
 * SIGNED-IN customer only and takes no address of its own. An endpoint that
 * accepted an email and said whether it was subscribed would let anyone with
 * a list of addresses find out who has an account here.
 *
 * So this does nothing for a signed-out visitor: there is no address to ask
 * about, the form behaves exactly as before, and Klaviyo deduplicates on
 * submit the way it already did.
 *
 * It also does nothing when the check fails. Failing closed would disable
 * the form for the length of a Klaviyo outage, which is a worse outcome than
 * letting someone subscribe twice to a list that merges duplicates anyway.
 */
(() => {
  const forms = document.querySelectorAll('.newsletter-form');
  if (!forms.length) return;

  const apply = (form) => {
    const input = form.querySelector('.field__input');
    const button = form.querySelector('.newsletter-form__button');
    if (!input) return;

    form.classList.add('newsletter-form--subscribed');
    input.value = '';
    input.placeholder = 'Already subscribed';
    input.disabled = true;
    input.setAttribute('aria-disabled', 'true');
    input.removeAttribute('required');

    if (button) {
      // Left in place, as asked: the row would otherwise reflow and lose the
      // shape people recognise. `disabled` rather than hidden, so it is
      // announced as unavailable rather than silently doing nothing.
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-label', 'Already subscribed');
    }

    const note = document.createElement('span');
    note.className = 'visually-hidden';
    note.textContent = 'You are already subscribed to these emails.';
    form.append(note);
  };

  fetch('/apps/portal/api/subscription', { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data || !data.known || !data.subscribed) return;
      forms.forEach(apply);
    })
    .catch(() => {});
})();
